import Vue from "vue";
import Vuex from "vuex";
import work from "./modules/work";
import xchange from "./modules/xchange";
import operatingSystem from "./modules/osdetect";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    work,
    xchange
  },
  state: {
    os: operatingSystem,
    viewportWidth: '100%'
  },
  mutations: {},
  actions: {
  }
});
